export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del contenedor"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aún no tiene exportación asignada"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container data"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to the list of containers"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have not yet assigned an export"])}
        }
      }
    }
  })
}